// frontend/user_services/src/utils/auth.js
import { jwtDecode } from 'jwt-decode'; // Make sure you've installed this: npm install jwt-decode

export const getAuthHeader = () => {
  const token = localStorage.getItem('token'); // Your JWT token key
  const headers = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;

    try {
      const decodedToken = jwtDecode(token);
      // Check if the JWT payload contains a 'csrf' field
      if (decodedToken.csrf) {
        headers['X-CSRF-TOKEN'] = decodedToken.csrf; // Add the CSRF token header
      }
    } catch (error) {
      console.error("Error decoding JWT token or missing CSRF token:", error);
      // Handle invalid token if necessary (e.g., clear localStorage, redirect to login)
      // For now, let's just log the error.
    }
  }
  return headers;
};